<span class="searchrounded">
  <input type="text" placeholder="Search" ([value])="(searchText)" (keyup)="changed($event)" />
  <mat-icon matPostfix>search</mat-icon>
</span>
